module.exports = __webpack_public_path__ + "img/GAME_CROSSTURTLE1.ce8ee90d.jpg";